module.exports = [{
      plugin: require('/Users/juanpablodelatorrevaldez/Desktop/curso-react/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
